
import React, { useState } from "react";
import { Badge, Button, Col, Dropdown, Table, Form } from "react-bootstrap";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { MdOutlineEdit, MdOutlineFilterAlt } from "react-icons/md";
import { PiTrash } from "react-icons/pi";
import { DeleteCommonAPI } from "../../../POS/APIServices/POS_API_Services";
import HelperService from "../../../Services/HelperService";
import { SearchParams } from "../../../assets/interfaces/FX_POS_Interfaces";
import { Headers, PaginationProps, TableActions } from "../../../assets/interfaces/commom_interfaces";
import { nsT } from "../../../i18n/i18nHelper";
import TablePagination from "../../Pagination";
import CommonModal from "../Modals/CommonModal";
import ConfirmationModal from "../Modals/ConfirmationModal";
import NoDataFoundComponent from "../NoDataFound";
import PageLoader from "../PageLoader/PageLoader";
import moment from "moment";
import { ExportExcel } from "../../../Services/FXAPIServices";
import { IoArrowBack } from "react-icons/io5";
import "./FXTable.scss"
import DatePicker from "react-datepicker";
import TimeRangePicker from "./CommonTimeRangePicker";
import LateTimer from "./Timer/LateTimer";
import { TooltipCustom } from "../Tooltip/Tooltip";
export type TableExport = {
    label?: string;
    api: string;
    // exportType: "csv" | "pdf" | "xlsx";
    fileName: string;
}

type CommonTableProps = {
    headers: Headers[];
    data: any[];
    searchParam?: SearchParams;
    setSearchParams?: (search: SearchParams | ((prev: SearchParams) => SearchParams)) => void;
    searchFilters?: any;
    setSearchFilters?: (filters: any | ((prev: any) => any)) => void;
    actions?: TableActions[];
    className?: string;
    loader?: boolean;
    listCall?: () => void;
    paginationRequired?: boolean;
    paginationProps?: PaginationProps;
    searchRequired?: boolean
    filterRequired?: boolean;
    showFilterRow?: boolean
    exportOption?: TableExport
};

const FXTable: React.FC<CommonTableProps> = ({
    headers,
    data,
    actions = [],
    className,
    loader, filterRequired, showFilterRow,
    listCall, searchParam,
    setSearchParams,
    searchFilters,
    setSearchFilters,
    paginationRequired,
    paginationProps, exportOption
}) => {
    const c = nsT("common");
    const [showImageModal, setShowImageModal] = useState(false)
    const [imageTitle, setImageTitle] = useState("");
    const [imageUrl, setImageURl] = useState('')
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedIdForDeleteAction, setSelectedIdForDeleteAction] = useState("")
    const [searchTableFilters, setTableFilters] = useState(searchFilters ? searchFilters : {});
    const [showCommonFilters, setShowCommonFilters] = useState(showFilterRow ? true : false)

    const handleFilterChange = (e: any, key: string) => {
        const rawValue = e.target?.value;
        const updatedFilters = {
            ...searchTableFilters,
            [key]: rawValue
        };
        setTableFilters(updatedFilters);
    }
    const handleSort = (header: Headers) => {
        if (!header.isSorting || !header.sortingKey) return;

        let direction: "ASC" | "DESC" = "ASC";
        if (searchParam?.sortBy === header.sortingKey && searchParam?.orderBy === "ASC") {
            direction = "DESC";
        }
        setSearchParams?.((prev: SearchParams) => ({
            ...prev,
            sortBy: header.sortingKey,
            orderBy: direction
        }));
    };
    const handleImageViewClick = (row: any) => {
        const imageHeader = headers.find((h) => h.headerType === "IMAGE");
        if (imageHeader && row[imageHeader.key]) {
            setImageURl(row[imageHeader.key]);
            setImageTitle(imageHeader.label || "Image Preview");
            setShowImageModal(true);
        } else {
            setImageURl("");
            setImageTitle("No Image Available");
            setShowImageModal(true);
        }
    };
    const handleDeleteAction = (row: any) => {
        setSelectedIdForDeleteAction(row.id)
        setShowDeleteModal(true);
    }
    const formatCurrency = (amount: number) => {
        return HelperService.formatCurrency(amount, 2);
    };
    const handleDelete = () => {
        if (!selectedIdForDeleteAction) {
            return
        }
        const deleteAction = actions.find(action => action.type === "DELETE");
        const deleteApi = deleteAction?.delete_api;
        DeleteCommonAPI(`${deleteApi}${selectedIdForDeleteAction}`, 'deleteBtnModal').then(() => {
            listCall?.()
        }).catch(() => { }).finally(() => {
            setShowDeleteModal(false)
        })
    }
    const handleParamChange = (name: string, value: string | number) => {
        setSearchParams?.((prev: SearchParams) => ({ ...prev, [name]: value }));
    }
    const isReservationDue = (row: any) => {
        if (!row?.reserved_date) return false;
        const [day, month, year] = row.reserved_date.split('/');
        const reservedDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
        );
        const today = new Date();
        reservedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return reservedDate <= today;
    };
    const renderActionButton = (action: any, row: any, i: number) => {
        const { type, onClick, is_accessCode } = action;

        const commonProps = {
            className: "d-flex align-items-center",
            size: "sm" as const,
            id: `${type.toLowerCase()}-btn-${row.id ?? row.transfer_id}`,
        };

        switch (type) {
            case "VIEW":
                return (
                    <Button key={`button${i}`} {...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        {c("view")}
                    </Button>
                );
            case "VIEW/EDIT":
                return (
                    <Button key={`button${i}`} {...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        View & Edit
                    </Button>
                );

            case "VIEW_IMAGE":
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-primary px-2" onClick={() => handleImageViewClick(row)}>
                        {c("view")}
                    </Button>
                );

            case "STOCK_IN":
                if (row.status === "DELIVERED") return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        {c("stock_in")}
                    </Button>
                );
            case "STOCK_OUT":
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        Stock Out
                    </Button>
                );
            case "PLACE_ORDER":
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        Place Order
                    </Button>
                );

            case "EDIT":
                if ((row.status === "DELIVERED" || row.status === "CONFIRMED" || row.status === "CANCELLED") || row?.has_action === false) return null;

                return (
                    <Button key={`button${i}`}{...commonProps} variant="link p-0 text-dark" onClick={() => onClick?.(row)}>
                        <MdOutlineEdit size={18} />
                    </Button>
                );

            case "DELETE":
                if (row?.has_action === false) return null;
                return (
                    <Button
                        key={`button${i}`} {...commonProps}
                        variant="link p-0 text-danger"
                        onClick={() => (is_accessCode ? onClick?.(row) : handleDeleteAction(row))}
                    >
                        <PiTrash size={18} />
                    </Button>
                );

            case "MARK":
                if (row.status === "PAID") return null;
                return (
                    <Button key={`button${i}`}{...commonProps} className="action-btn text-uppercase" variant="success px-2" onClick={() => onClick?.(row)}>
                        Mark as Paid
                    </Button>
                );

            case "VIEW1":
                if (row.status !== "PAID") return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        {c("view")}
                    </Button>
                );

            case "PUNCH_IN":
                if (row.has_punched_in) return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-success" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Punch In
                    </Button>
                );

            case "PUNCH_OUT":
                if (!row.has_punched_in) return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-danger" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Punch Out
                    </Button>
                );
            case "APPROVE":
                if (row.status !== 'PENDING' && row.status !== 'PENDING_CONFIRMATION') return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-success" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Approve
                    </Button>
                );
            case "REJECT":
                if (row.status !== 'PENDING' && row.status !== 'PENDING_CONFIRMATION') return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-danger" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Reject
                    </Button>
                );
            case "RECEIVED":
                if (row.status !== 'APPROVED') return null;
                return (
                    <Button key={`button${i}`}  {...commonProps}
                        variant="outline-success"
                        className="px-2 action-btn text-uppercase font-medium"
                        onClick={() => onClick?.(row)}>
                        Received
                    </Button>
                );
            case "CANCEL":
                if (row.status !== 'APPROVED' && row.status !== 'PENDING_CONFIRMATION') return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-danger" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Cancel
                    </Button>
                );
            case "CANCEL1":
                if (row.status !== 'APPROVED') return null;
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-danger" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        Cancel
                    </Button>
                );

            case "RECONCILE":
                return (
                    <Button key={`button${i}`}{...commonProps} variant="outline-warning" className="px-2 action-btn text-uppercase font-medium" onClick={() => onClick?.(row)}>
                        RECONCILE
                    </Button>
                );
            case "SEND_CAMPAIGN":
                return (
                    <Button key={`button${i}`}{...commonProps} className="action-btn text-uppercase" variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        Send Campaign
                    </Button>
                );
            case "15_MIN":
                return (
                    !row.arrived_at && row.status !== "CANCELLED" &&
                    <Button key={`button${i}`}{...commonProps} id={`add_15_mins_${row?.id}`} className="action-btn text-uppercase" variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        +15 Mins
                    </Button>
                );
            case "DOWNLOAD_QR":
                return (
                    !row.arrived_at &&
                    <Button key={`button${i}`}{...commonProps} id={`downloadqr_${row?.id}`} className="action-btn text-uppercase" variant="outline-primary px-2" onClick={() => onClick?.(row)}>
                        Download QR
                    </Button>
                );
            case "ARRIVED":
                return (
                    !row.arrived_at && row.status !== "CANCELLED" && isReservationDue(row) ? (
                        <Button
                            key={`button${i}`}{...commonProps}
                            id={`mark_as_arrived_${row?.id}`}
                            variant="outline-success"
                            className="p-2 action-btn text-uppercase font-medium d-inline-flex align-items-center gap-1"
                            onClick={() => onClick?.(row)}
                        >
                            <span className="d-flex align-items-center text-nowrap">
                                <i className="bi bi-check-circle me-1"></i>
                                Mark Arrived
                            </span>
                        </Button>
                    ) : (
                        <>
                            {row.arrived_at && (
                                <Badge
                                    pill
                                    bg={row?.status === "CANCELLED" ? "danger" : "success"}
                                    className="px-3 py-2 d-inline-flex align-items-center gap-1"

                                >
                                    <i className="bi bi-check-circle"></i> {row.arrived_at ? "Arrived" : HelperService.titleCase(row?.status ?? "-")}
                                </Badge>)}
                        </>
                    ));

            default:
                return null;
        }
    };
    const handleExport = async (type: string) => {
        const params = {
            ...searchParam,
            isExport: true,
            exportType: type
        };
        const fileName = exportOption?.fileName + moment().format("YYYYMMDD_HHmmss") + (type === 'EXCEL' ? ".xlsx" : ".csv");
        const queryString = HelperService.toQueryString(params);
        const url = exportOption?.api
        url && ExportExcel(url, queryString, searchFilters, "export-button", fileName);
    };
    const resetFilters = () => {
        const resetFiltersObj = headers.reduce((acc: any, header) => {
            acc[header.sortingKey] = header.sortingKey === 'net_total' ? null : '';
            return acc;
        }, {} as { [key: string]: any });

        setTableFilters(resetFiltersObj);
        setSearchParams?.((prev: SearchParams) => ({
            ...prev,
            page: 1
        }));

        setSearchFilters?.(resetFiltersObj);
        setShowCommonFilters(false);
    }
    const getNestedValue = (obj: any, path: string, type?: string): any => {
        if (!obj || !path) return "";
        const value = path.split('.').reduce((acc, key) => acc?.[key], obj);
        if (type === "MOBILE") {
            const dialCode =
                obj?.dial_code ||
                obj?.customer?.dial_code ||
                obj?.customer_dial_code ||
                "";

            const mobile =
                value ||
                obj?.mobile_number ||
                obj?.customer?.mobile_number ||
                obj?.customer_mobile_number ||
                "";
            return dialCode && mobile ? `${dialCode}-${mobile}` : mobile || "";
        }

        if (Array.isArray(value)) {
            return value
                .map((item) => item?.table_no || item?.title || JSON.stringify(item))
                .join(", ");
        }

        if (type === "DATE" && value) {
            const date = new Date(value);
            return isNaN(date.getTime()) ? value : date.toLocaleDateString();
        }

        if (type === "TIME" && value) {
            if (typeof value === "string") {
                const timeParts = value.split(':');
                if (timeParts.length >= 2) {
                    const hours = parseInt(timeParts[0], 10);
                    const minutes = parseInt(timeParts[1], 10);
                    if (!isNaN(hours) && !isNaN(minutes)) {
                        const ampm = hours >= 12 ? 'PM' : 'AM';
                        const displayHours = hours % 12 || 12;
                        const displayMinutes = String(minutes).padStart(2, '0');
                        return `${displayHours}:${displayMinutes} ${ampm}`;
                    }
                }
            }
            return value;
        }

        return value ?? "";
    };

    const formatDate = (date: Date | null) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    return (
        <>
            <div className="d-flex justify-content-between ">
                <Col lg={8} className="d-flex gap-3">
                    {showCommonFilters && filterRequired &&
                        <a onClick={resetFilters} className="cursor-pointer text-dark">
                            <IoArrowBack size={16} /> Reset Filters
                        </a>
                    }

                </Col>
                <Col lg={4}>
                    <div className="d-flex align-items-end justify-content-end mb-3">
                        <div className="d-flex gap-3 align-items-end">
                            {exportOption && data?.length > 0 &&
                                <Dropdown className="me-2">
                                    <Dropdown.Toggle id="export-dropdown" variant="primary">
                                        {exportOption.label ? exportOption.label : 'Export'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end" style={{ minWidth: '120px' }}>
                                        <Dropdown.Item onClick={() => {
                                            handleExport('EXCEL');
                                        }}>
                                            EXCEL
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => {
                                            handleExport('CSV');
                                        }}>
                                            CSV
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                            {filterRequired &&
                                <button onClick={() => { setShowCommonFilters(!showCommonFilters) }} type="button" id="filter-dropdown" aria-expanded="false" className="dropdown-toggle btn btn-outline-light  text-dark bg-light no-arrow">
                                    <MdOutlineFilterAlt size={22} className=" cursor-pointer" />
                                </button>
                            }
                        </div>
                    </div>
                </Col>
            </div>
            {/* <div className="d-flex justify-content-between align-items-center mb-2">
                <Col>
                    {searchRequired &&
                        <div className="col-lg-4 mb-3">
                            <CommonSearch
                                onSearch={((query: string) => handleParamChange('keyword', query))} />
                        </div>}
                </Col>
            </div> */}
            <Table responsive hover className={`table-style ${className || ""}`}>
                <thead >
                    <tr>
                        <th>{c('sr_no')}</th>
                        {headers?.map((header) => (
                            <th
                                key={header.key}
                                onClick={() => handleSort(header)}
                                className="column-header col"
                                style={{ cursor: header.isSorting ? "pointer" : "default" }}
                            >
                                {header.label}{" "}
                                {header.isSorting &&
                                    (
                                        (searchParam?.sortBy === header.sortingKey) ||
                                        (searchParam?.sortBy === undefined && header.isDefaultSorting)
                                    ) &&
                                    (searchParam?.orderBy === "ASC" ? <BsArrowUp /> : <BsArrowDown />)
                                }
                            </th>

                        ))}
                        {actions.length > 0 && <th className="text-center">{c('actions')}</th>}
                    </tr>
                    {filterRequired &&
                        <tr className={`filter-wrapper filter-row ${!showCommonFilters ? "collapsed" : "expanded"}`}>
                            <td></td>
                            {headers.map((header: any, ind: number) => (
                                <td key={header.key}>
                                    {header.isHideFilter ? null :
                                        <div>
                                            {
                                                header.headerType === "DATE" || header.headerType === "DATE_FORMAT" ? (
                                                    <DatePicker
                                                        selectsRange
                                                        popperPlacement="bottom-start"
                                                        dateFormat='dd/MM/yyyy'
                                                        startDate={
                                                            searchTableFilters[`from_${header.sortingKey}`]
                                                                ? new Date(searchTableFilters[`from_${header.sortingKey}`])
                                                                : null
                                                        }
                                                        endDate={
                                                            searchTableFilters[`to_${header.sortingKey}`]
                                                                ? new Date(searchTableFilters[`to_${header.sortingKey}`])
                                                                : null
                                                        }
                                                        onChange={(dates: [Date | null, Date | null]) => {
                                                            const [start, end] = dates;
                                                            setTableFilters({
                                                                ...searchTableFilters,
                                                                [`from_${header.sortingKey}`]: formatDate(start),
                                                                [`to_${header.sortingKey}`]: formatDate(end),
                                                            });
                                                            if (start && end)
                                                                setSearchFilters?.({
                                                                    ...searchTableFilters,
                                                                    [`from_${header.sortingKey}`]: start
                                                                        ? formatDate(start)
                                                                        : "",
                                                                    [`to_${header.sortingKey}`]: end
                                                                        ? formatDate(end)
                                                                        : "",
                                                                })
                                                            setSearchParams?.((prev: SearchParams) => ({
                                                                ...prev,
                                                                page: 1
                                                            }));
                                                            if (!start && !end)
                                                                setSearchFilters?.({
                                                                    ...searchTableFilters,
                                                                    [`from_${header.sortingKey}`]: "",
                                                                    [`to_${header.sortingKey}`]: "",
                                                                })
                                                        }}
                                                        className="form-control form-control-sm"
                                                        placeholderText={`Select ${header.label} range`}
                                                    />

                                                ) :
                                                    header.headerType === "TIME" ? (
                                                        <>
                                                            <TimeRangePicker

                                                                onTimeChange={(start: any, end: any) => {
                                                                    setTableFilters({
                                                                        ...searchTableFilters,
                                                                        [`${header.sortingKey}`]: start,
                                                                        [`${header.sortingKey}`]: end,
                                                                    });
                                                                    if (start && end)
                                                                        setSearchFilters?.({
                                                                            ...searchTableFilters,
                                                                            [`from_${header.sortingKey}`]: start
                                                                                ? start
                                                                                : "",
                                                                            [`to_${header.sortingKey}`]: end
                                                                                ? end
                                                                                : "",
                                                                        })
                                                                    setSearchParams?.((prev: SearchParams) => ({
                                                                        ...prev,
                                                                        page: 1
                                                                    }));
                                                                    if (!start && !end)
                                                                        setSearchFilters?.({
                                                                            ...searchTableFilters,
                                                                            [`from_${header.sortingKey}`]: "",
                                                                            [`to_${header.sortingKey}`]: "",
                                                                        })
                                                                }}
                                                            />
                                                        </>
                                                    ) : header.headerType === "DROPDOWN" && header.dropdownValues ? (
                                                        <select
                                                            className="form-select form-control-sm"
                                                            value={searchTableFilters[header.key] || ""}
                                                            onChange={(e: any) => {
                                                                const updatedFilters = {
                                                                    ...searchTableFilters,
                                                                    [header.key]: e.target.value,
                                                                }
                                                                setTableFilters(updatedFilters);
                                                                setSearchFilters?.(updatedFilters);
                                                            }}
                                                        >
                                                            <option value="">All</option>
                                                            {header.dropdownValues?.map((option: any, idx: number) => (
                                                                <option key={idx} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )
                                                        :
                                                        header.headerType !== "STATUS" ? (
                                                            <input
                                                                type={header.headerType === "NUMBER"
                                                                    ? "number" : "text"
                                                                }
                                                                className="form-control form-control-sm"
                                                                placeholder={`Search ${header.label}`}
                                                                value={searchTableFilters[header.key as keyof typeof searchTableFilters] || ""}
                                                                onChange={(e: any) => handleFilterChange(e, header.key)}
                                                                onKeyDown={(e) => {
                                                                    const trimValues = (obj: any): any => {
                                                                        if (obj == null) return obj;
                                                                        if (typeof obj === "string") return obj.trim();
                                                                        if (Array.isArray(obj)) return obj.map(trimValues);
                                                                        if (typeof obj === "object") {
                                                                            return Object.keys(obj).reduce((acc: any, key) => {
                                                                                acc[key] = trimValues(obj[key]);
                                                                                return acc;
                                                                            }, {});
                                                                        }
                                                                        return obj;
                                                                    };

                                                                    if (e.key === "Enter") {
                                                                        const trimmedFilters = trimValues(searchTableFilters);
                                                                        setSearchFilters?.(trimmedFilters);
                                                                    }
                                                                }}
                                                            />
                                                        ) :
                                                            header.statusValues ? (
                                                                < select
                                                                    className="form-select form-control-sm"
                                                                    value={searchTableFilters.status || ""}
                                                                    onChange={(e: any) => {
                                                                        const updatedFilters = {
                                                                            ...searchTableFilters,
                                                                            status: e.target.value,
                                                                        }
                                                                        setTableFilters(updatedFilters);
                                                                        setSearchFilters?.(updatedFilters);
                                                                    }}
                                                                >
                                                                    <option value="">All</option>
                                                                    {header.statusValues?.map((status: any, idx: number) => (
                                                                        <option key={idx} value={status.value}>
                                                                            {status.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            ) :
                                                                (
                                                                    <select
                                                                        className="form-select form-control-sm"
                                                                        value={searchTableFilters.status || ""}
                                                                        onChange={(e: any) => {
                                                                            const updatedFilters = {
                                                                                ...searchTableFilters,
                                                                                status: e.target.value,
                                                                            }
                                                                            setTableFilters(updatedFilters);
                                                                            setSearchFilters?.(updatedFilters);
                                                                            setSearchParams?.((prev: SearchParams) => ({
                                                                                ...prev,
                                                                                page: 1
                                                                            }));
                                                                        }}
                                                                    >
                                                                        <option value="">All</option>
                                                                        <option value="PENDING">Pending</option>
                                                                        <option value="DELIVERED">Delivered</option>
                                                                    </select>
                                                                )

                                            }
                                        </div>
                                    }
                                </td>
                            ))}
                            <td></td>
                        </tr>
                    }
                </thead>
                {loader ? (
                    <tbody>
                        <tr key={`loader_${headers.length + 2}`}>
                            <td colSpan={headers.length + 2} className="text-center">
                                <PageLoader minHeight="49vh" />
                            </td>
                        </tr>
                    </tbody>
                ) :
                    data && data.length > 0 &&
                    <tbody>
                        {data?.map((row, rowIndex) => (
                            <tr key={"row3_" + rowIndex}>
                                <td>{((searchParam?.page ?? 1) - 1) * (paginationProps?.itemsCountPerPage ?? 10) + rowIndex + 1}</td>
                                {headers.map((header) => (
                                    header.headerType === "TIMER" ? (
                                        <td>{
                                            row.arrived_at === null &&
                                                new Date(`${row.reserved_date} ${row.reserved_time}`) < new Date() ? (
                                                <LateTimer reservedDate={row.reserved_date} reservedTime={row.reserved_time} />

                                            ) : (
                                                <Badge bg={row?.status === "PENDING" ? "warning text-dark" : row?.status === "CONFIRMED" ? "success" : ""}><span className="font-12">{
                                                    HelperService.titleCase(row?.status ?? "-")}</span></Badge>
                                            )}
                                        </td>
                                    ) :
                                        header.headerType === 'NUMBER_CLICK' ?
                                            <td key={header.key + "_" + rowIndex} className="text-primary" style={{ cursor: 'pointer' }}>
                                                <span onClick={() => header.onColumnClick?.(row)}>{row[header.key]}</span>
                                            </td>
                                            : header.headerType === "STATUS" ? header.headerType === "STATUS" && (
                                                <td className="text-cendter">
                                                    {(() => {
                                                        const statusValue = row[header.key];
                                                        const statusMap: Record<
                                                            string,
                                                            { text: string; variant: string }
                                                        > = {
                                                            Inactive: { text: "Inactive", variant: "danger" },
                                                            INACTIVE: { text: "Inactive", variant: "danger" },
                                                            Paused: { text: "Paused", variant: "secondary" },
                                                            PAUSED: { text: "Paused", variant: "secondary" },
                                                            PENDING: { text: "Pending", variant: "warning" },
                                                            PAID: { text: "Paid", variant: "success" },
                                                            PARTIAL: { text: "Partial Paid", variant: "warning" },
                                                            PARTIAL_DELIVERED: { text: "Partial Delivered", variant: "danger" },
                                                            DELIVERED: { text: "Delivered", variant: "success" },
                                                            CONFIRMED: { text: "Confirmed", variant: "success" },
                                                            REJECTED: { text: "Rejected", variant: "danger" },
                                                            APPROVED: { text: "Approved", variant: "success" },
                                                            NOT_DELIVERED: { text: "Not Delivered", variant: "warning" },
                                                            INTRANSIT: { text: "In Transit", variant: "warning" },
                                                            PENDING_CONFIRMATION: { text: "Pending Confirmation", variant: "warning" },
                                                            CANCEL: { text: "Cancelled", variant: "danger" },
                                                            CANCELLED: { text: "Cancelled", variant: "danger" },
                                                            RECEIVED: { text: "Received", variant: "success" },
                                                            "In Stock": { text: "In Stock", variant: "success" },
                                                            "Expiry Soon": { text: "Expiry Soon", variant: "info" },
                                                            Expired: { text: "Expired", variant: "danger" },
                                                            "Low Stock": { text: "Low Stock", variant: "warning" },
                                                            Active: { text: "Active", variant: "success" },
                                                        };

                                                        const status = statusMap[statusValue] || statusMap["Active"];
                                                        return <Badge bg={status.variant}><span className="font-12">{status.text}</span></Badge>;
                                                    })()}
                                                </td>
                                            )
                                                : header.headerType === "STATUS_TOGGLE" ? (
                                                    <td key={header.key + "_" + rowIndex} className="text-start">
                                                        <Form.Check
                                                            type="switch"
                                                            id={`status_toggle_${header.key}_${row.id}`}
                                                            checked={Boolean(row[header.key])}
                                                            label=""
                                                            className="mb-0 d-inline-block"
                                                            onChange={() => header.onColumnClick?.(row)}
                                                        />
                                                    </td>
                                                )
                                                    : header.headerType === 'DATE' ?
                                                        <td key={header.key + "_" + rowIndex}>
                                                            {header.key.includes('.')
                                                                ? getNestedValue(row, header.key) || "-"
                                                                : row[header.key] || "-"
                                                            }
                                                        </td>
                                                        : header.headerType === "DATE_FORMAT" ?
                                                            <td key={header.key + "_" + rowIndex}>
                                                                {HelperService.getFormatedDate(row[header.key], 'DD/MM/YYYY') || "-"}
                                                            </td> :

                                                            header.headerType === 'IMAGE' ? (
                                                                <td
                                                                    key={header.key + "_" + rowIndex}
                                                                    style={{ verticalAlign: "middle" }}
                                                                >
                                                                    {row[header.key] ? (
                                                                        <img
                                                                            src={row[header.key]}
                                                                            alt="preview"
                                                                            onClick={() => header.onColumnClick?.(row)}
                                                                            style={{
                                                                                width: "50px",
                                                                                height: "50px",
                                                                                objectFit: "cover",
                                                                                borderRadius: "8px",
                                                                                cursor: header.onColumnClick ? "pointer" : "default",
                                                                                border: "1px solid #ddd"
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <span className="text-muted">No Image</span>
                                                                    )}
                                                                </td>
                                                            ) : header.headerType === 'URL' ? (
                                                                <td key={header.key + "_" + rowIndex}>
                                                                    {row[header.key] ? (
                                                                        <a
                                                                            href={row[header.key]}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            onClick={() => header.onColumnClick?.(row)}
                                                                            style={{
                                                                                color: "#007bff",
                                                                                textDecoration: "underline",
                                                                                wordBreak: "break-all",
                                                                            }}
                                                                        >
                                                                            {row[header.key].length > 40
                                                                                ? row[header.key].substring(0, 40) + "..."
                                                                                : row[header.key]}
                                                                        </a>
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                    )}
                                                                </td>
                                                            ) : header.headerType === 'ARRAY' ? (
                                                                <td key={header.key + "_" + rowIndex}>
                                                                    <ul className="p-0 m-0">
                                                                        {Array.isArray(row[header.key]) && row[header.key].length > 0 ? (
                                                                            row[header.key].map((val: string, i: number) => (
                                                                                <li key={i}>{val}</li>
                                                                            ))
                                                                        ) : (
                                                                            <ul className="text-muted">--</ul>
                                                                        )}</ul>
                                                                </td>
                                                            ) : header.headerType === 'AMOUNT' ?
                                                                <td>
                                                                    {row[header.key] ? formatCurrency(row[header.key]) : "-"}
                                                                </td>
                                                            : header.headerType === 'TOOLTIP' ? (
                                                                <td key={header.key + "_" + rowIndex}>
                                                                    <TooltipCustom
                                                                        id={`tooltip_${header.key}_${row.id}`}
                                                                        text={row[header.key] || ""}
                                                                        maxLength={header.maxLength || 50}
                                                                    />
                                                                </td>
                                                            )

                                                                :
                                                                <td key={`${header.key}_${rowIndex}`}>
                                                                    <span
                                                                        onClick={() => header?.onColumnClick?.(row)}
                                                                        className={header?.onColumnClick ? "text-primary cursor-pointer" : ""}
                                                                        id={`${header.key}_${row.id}`}
                                                                    >
                                                                        {header.key.includes('.') || header?.isSplitRequired || header.headerType === "TIME" || header.headerType === "MOBILE"
                                                                            ? getNestedValue(row, header.key, header.headerType) || "-"
                                                                            : row[header.key] || "-"}
                                                                    </span>
                                                                </td>
                                ))}
                                {actions.length > 0 && (
                                    <td className="text-center">
                                        <div key={`actions_${rowIndex}`} className="d-flex gap-2 justify-content-end">
                                            {actions.map((action, i) => renderActionButton(action, row, i))}
                                        </div>
                                    </td>
                                )}

                            </tr>
                        ))
                        }
                    </tbody>
                }
                {!loader && data && data.length === 0 &&
                    (
                        <tbody>
                            {/* <tr key="loader"> */}
                            <td colSpan={headers.length + 2} className="text-center">
                                <NoDataFoundComponent />
                            </td>
                            {/* </tr> */}
                        </tbody>
                    )}
            </Table >
            {paginationRequired &&
                <TablePagination {...paginationProps} changePage={(page: number) => handleParamChange('page', page)} />
            }
            {
                showImageModal && <CommonModal
                    show={showImageModal}
                    handleClose={() => setShowImageModal(false)}
                    title={imageTitle}
                    url={imageUrl}
                />
            }
            {
                showDeleteModal &&
                <ConfirmationModal handleYesClick={handleDelete} show={showDeleteModal} setShow={(flag) => setShowDeleteModal(flag)} />
            }

        </>
    );
};

export default FXTable;
